import { render, staticRenderFns } from "./Certificados.vue?vue&type=template&id=a120a05a&scoped=true&"
import script from "./Certificados.vue?vue&type=script&lang=js&"
export * from "./Certificados.vue?vue&type=script&lang=js&"
import style0 from "./Certificados.vue?vue&type=style&index=0&id=a120a05a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a120a05a",
  null
  
)

export default component.exports